import { RouterLink } from '@angular/router';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ScrollToService } from '@df/dom/scroll/scroll-to.service';
import { BasketService, IAddToBasketSuccessEventData } from '@df/session/api/basket/basket.service';

import { ButtonStyleComponent } from '../../common/buttons/button-style/button-style.component';
import { DfEventService } from '@df/core/service/df-event';

export const BASKET_INTERACTION_EXPERIMENT_ID = 'basketInteraction';

@Component({
    selector: 'basket-notification-bar',
    templateUrl: './basket-notification-bar.html',
    styleUrls: ['./basket-notification-bar.scss'],
    imports: [ButtonStyleComponent, RouterLink, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketNotificationBarComponent extends UiComponent {
    protected productName?: string;

    protected display = false;

    private basketService = inject(BasketService);

    private scrollToService = inject(ScrollToService);

    private app = inject(App);

    private readonly dfEventService = inject(DfEventService);

    override ngOnInit(): void {
        super.ngOnInit();
        this.subscriptions.add(
            this.basketService.subscribeToAddToBasketSuccess((eventData: IAddToBasketSuccessEventData) => {
                if (this.experimentActive) {
                    const productId = eventData?.request?.products?.[0]?.id;
                    if (productId) {
                        const product = this.app.resources.product.getExisting(productId);
                        const productName = product?.parent?.data?.name || product?.data?.name;
                        if (productName) {
                            this.productName = productName;
                            this.display = true;
                            this.detectChanges();
                            this.scrollToService.scrollTo(0, { behavior: 'smooth' });
                        }
                    }
                }
            })
        );
    }

    protected get isSM(): boolean {
        return this.client.sizeId < 2;
    }

    private get experimentActive(): boolean {
        return this.app.ab.getVariant(BASKET_INTERACTION_EXPERIMENT_ID) === 'B';
    }

    protected track() {
        this.dfEventService.dispatch({
            id: 'dfGtmCustomEvent',
            data: {
                name: 'view_cart_click',
                data: undefined
            }
        });
    }
}
